import { addLocale, locale } from "primereact/api";
import CryptoJS from "crypto-js";

export function validateEmail(email) {
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export function userSession() {
    try {
        return JSON.parse(localStorage.usuarioWGSol);
    } catch (e) {
        return {};
    }
}

export function showProcessing() {
    try {
        var element = document.getElementById("App-process-bar");
        element.classList.add("App-process-bar-enabled");
    } catch (e) {}
}

export function hideProcessing() {
    try {
        var element = document.getElementById("App-process-bar");
        element.classList.remove("App-process-bar-enabled");
    } catch (e) {}
}

export function hasAuthority(hole) {
    try {
        if (localStorage.usuarioWGSol === undefined) {
            return false;
        }

        return (
            JSON.parse(localStorage.usuarioWGSol).autoridades.filter((a) => a.authority === hole)
                .length > 0
        );
    } catch (e) {
        return false;
    }
}

export function hasAnyAuthority(holes = []) {
    try {
        if (localStorage.usuarioWGSol === undefined) {
            return false;
        }

        return (
            JSON.parse(localStorage.usuarioWGSol).autoridades.filter((a) => holes.includes(a.authority))
                .length > 0
        );
    } catch (e) {
        return false;
    }
}

export function isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(navigator.userAgent);
}



